import type {BlockedPaymentMethod} from '@/services/blockedPaymentMethodService';
import type {AfriexCountry} from '@/types';
import {AfriexTransactionChannel} from '@/types';

export type BlockedPaymentMethodModalProps = {
  onClose: VoidFunction;
  showModal: boolean;
  handleSave: (body: BlockedPaymentMethod) => Promise<void>;
  countryList: AfriexCountry[];
};
export type BlockedPaymentMethodTableProps = {
  list: BlockedPaymentMethod[];
  onRemove: (id: string) => Promise<void>;
};
type LabelType = Partial<Record<AfriexTransactionChannel, string>>;
export const transationTypeToLabel: LabelType = {
  [AfriexTransactionChannel.CARD]: 'Debit Card',
  [AfriexTransactionChannel.BANK_ACCOUNT]: 'Bank Account',
  [AfriexTransactionChannel.MOBILE_MONEY]: 'Mobile Money',
};

export const transactionTypeToProvider: LabelType = {
  [AfriexTransactionChannel.CARD]: 'Card Issuer',
  [AfriexTransactionChannel.BANK_ACCOUNT]: 'Bank Name',
  [AfriexTransactionChannel.MOBILE_MONEY]: 'Network Provider',
};

export const transactionTypeToIdentifier: LabelType = {
  [AfriexTransactionChannel.CARD]: 'Card Number',
  [AfriexTransactionChannel.BANK_ACCOUNT]: 'Account Number',
  [AfriexTransactionChannel.MOBILE_MONEY]:
    'Phone Number (in international format e.g. +123456789)',
};
